import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';
import { classPermissionsPrereq, EBuiltInIds, EJavaClassNames, EPermissionsConstants, hasObjectReadPermissionsPrereq, hasVisibleObjectPrereq } from '@adaptiva/data-service';

const _productName: string = Licensing.Products.Internal.CIM;
const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(_productName);

export const CLOUD_PORTAL_NAVIGATION: IProductNavigation = {
	productName: _productName,
	route: _baseUrl,
	sidenav: {
		productName: _productName,
		sections: [
			{
				items: [
					{
						display: 'Home',
						route: _baseUrl,
						icon: 'faHome',
						linkedRoutes: [
							`${_baseUrl}/company/:id`,
							`${_baseUrl}/tenant/:id`,
						],
					},
				]
			},
			{
				title: 'Adaptiva Support',
				items: [
					{
						display: 'Service Configuration',
						route: `${_baseUrl}/service-config`,
						icon: 'faCloud',
						prerequisites: [hasObjectReadPermissionsPrereq(EBuiltInIds.CLOUD_SERVICE_CONFIGURATION)],
					},
					{
						display: 'Service Regions',
						route: `${_baseUrl}/service-region`,
						icon: 'faGlobe',
						prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.CloudServiceRegion)],
					},
					{
						route: `${_baseUrl}/companies`,
						display: 'Companies',
						icon: 'faBriefcase',
						prerequisites: [
							classPermissionsPrereq(
								EJavaClassNames.CloudInstanceCompany,
								EPermissionsConstants.READ_PERMISSION_INDEX
							)
						],
					},
					{
						route: `${_baseUrl}/tenants`,
						display: 'Tenants',
						icon: 'faServer',
						prerequisites: [
							classPermissionsPrereq(
								EJavaClassNames.CompanyTenantConfiguration,
								EPermissionsConstants.READ_PERMISSION_INDEX
							)
						],
					},
					{
						display: 'Tenant Upgrade',
						route: `${_baseUrl}/tenant-upgrade`,
						icon: 'faArrowToTop',
						prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.AdaptivaTenantConfiguration)],
					},
					{
						display: 'Partner Context',
						route: `${_baseUrl}/partner-context`,
						icon: 'faHandshake',
						prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.CloudPartnerContext)]
					}
				]
			}
		],
	}
};

